import React from "react"
import { Row, Col, Card } from "antd"
import { useMediaQuery } from "react-responsive"

const AboutSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  // const integrations = [
  //   "Shippy Pro", "eBay", "Etsy", "Shopify", "WooCommerce", "Magento", "OpenCart", "PrestaShop", "Amazon"
  // ]
  const integrations = {
    "shopify": {
      name: "Shopify",
      active: true,
      link: "/shopify_integracija"
    },
    "ebay": {
      name: "eBay",
      active: true,
      link: "/ebay_integracija"
    },
    "etsy": {
      name: "Etsy",
      active: true,
      link: "/etsy_integracija"
    },
    "woocommerce": {
      name: "WooCommerce",
      active: true,
      link: "/woocommerce_iskiepis"
    },
    "opencart": {
      name: "OpenCart",
      active: true,
      link: "/opencart_iskiepis"
    },
    "amazon": {
      name: "Amazon",
      active: false,
    },
    "shippypro": {
      name: "Shippy Pro",
      active: false,
    },
    "magento": {
      name: "Magento",
      active: false
    },
    "prestashop": {
      name: "PrestaShop",
      active: false
    },
  }

  return (
    <>
      <Row
        gutter={{ lg: 16 }}
        align="middle"
        style={{
          padding: isMobileScreen ? "15px" : ""
        }}
      >
        <Col span={24} lg={{ offset: 5, span: 14 }}
          style={
            {
              textAlign: isMobileScreen ? "left" : "center",
              marginBottom: "30px"
            }
          }
        >
          <div className="section-title about-title" style={{ marginTop: isMobileScreen ? "" : "-35px" }}>
            {"Integracijos"}
          </div>
        </Col>
        <Col span={24} lg={{ offset: 2, span: 20 }}>
          <Row gutter={16}>
            {Object.entries(integrations).map((integration, index) => (
              <Col span={24} lg={{ span: 8 }} className={`integration-card ${!integration[1].active && "disabled"}`} key={index}>
                <Card>
                  <img src={`./images/integrations/${integration[0]}.svg`} />
                  {integration[1].active ? (
                    <a href={integration[1]?.link}>
                      <button>
                        {"Peržiūrėti"}
                      </button>
                    </a>
                  ) : (
                    <button disabled>
                      {"Jau greitai!"}
                    </button>
                  )}
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default AboutSection
